<template>
    <el-dialog custom-class="add-device" :visible.sync="visible" lock-scroll :visible="true" width="500px" :close-on-click-modal="false" :before-close="cancel">
        <div slot="title" class="add-title">添加设备
            <el-popover :offset="192" popper-class="title-tips" width="290" trigger="hover" placement="bottom-end">
                <div class="content">
                    <div class="sub-item">
                        <h5 class="sub-title">检查当前App是否已升至5.45版本</h5>
                        <p>Android Bilibili -> 左上角“菜单” -> 左下角“设置” -> 帮助 -> 检查更新模块</p>
                        <p>IOS Bilibili -> 底部“我的” -> 右上角“设置” -> 关于哔哩哔哩 -> 当前版本</p>
                    </div>
                </div>
                <div slot="reference" class="tips-detail">若二维码未识别，请检查当前App版本<i class="icon-detail"></i></div>
            </el-popover>
        </div>
        <el-form :model="deviceInfo" label-width="100px" :rules="deviceRules" ref="deviceForm">
            <el-form-item label="设备号：" prop="deviceNum">
                <el-input v-model="deviceInfo.deviceNum" class="device-input"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="2" :maxlength="30" placeholder="请输入内容" v-model="deviceInfo.remark"class="device-input"></el-input>
                <div class="len-remark">{{deviceInfo.remark.length}} / 30</div>
            </el-form-item>
        </el-form>
        <div class="qrcode-content">
            <div class="tip">使用哔哩哔哩APP扫描下方二维码，可识别扫码手机的设备号</div>
            <img :src="codeUrl" class="qrcode" width="200">
        </div>
        <div slot="footer" class="footer-btn">
            <btn :type="1" info="取消" @click="cancel"></btn>
            <btn :type="0" info="确定" @click="submitDeviceInfo"></btn>
        </div>
    </el-dialog>
</template>
<script>
import dao from '@/lib/dao';
import Btn from '@/components/Button.vue';
import QRCode from 'qrcode';

export default {
    props: ['visible', 'appId'],
    components: {
        Btn
    },
    data() {
        let vm = this;
        let deviceValidator = (rule,value,callback) => {
            if (!value) {
                callback(new Error('请输入您要添加的设备号'));
            } else if(!value.trim().length) {
                callback(new Error('设备号不可为空'));
            } else {
                callback();
            }
        };
        return {
            deviceInfo: {
                deviceNum: '',
                remark: ''
            },
            deviceRules: {
                'deviceNum': [
                    { required: true, validator: deviceValidator, trigger: ['blur']},
                ]
            },
            codeUrl: ''
        }
    },
    methods: {
        getQrcode() {
            QRCode.toDataURL(`https://miniapp.bilibili.com/manager/deviceinfo`)
                .then(url => {
                    this.codeUrl = url;
                })
                .catch(err => {
                    console.error(err)
                })
        },
        submitDeviceInfo() {
            this.$refs.deviceForm.validate(valid => {
                if(!valid) {
                    return false
                }
                dao.shop.addDevices({
                    appId: this.appId,
                    buvid: this.deviceInfo.deviceNum,
                    remark: this.deviceInfo.remark
                }).then(data => {
                    this.$message.success('设备号添加成功～')
                    this.$emit('close');
                    this.$emit('refresh');
                }).catch(msg => this.$message.error(msg));
            });
        },
        cancel() {
            this.$emit('close');
        }
    },
    mounted() {
        this.getQrcode();
    }
}
</script>
<style lang="less" scoped>
.add-device {
    text-align: center;
    position: relative;
    .add-title {
        position: relative;
        font-size: 16px;
        font-weight: 450;
        color: #5C667E;
        .tips-detail {
            color: #777;
            display: inline-block;
            font-size: 12px;
            .icon-detail {
                display: inline-block;
                position: absolute;
                top: 7px;
                width: 12px;
                height: 12px;
                margin-left: 5px;
                background: url(../../assets/icon_attention@2x.png) no-repeat center/contain;
                cursor: pointer;
            }
        }
    }
    .device-input {
        width: 80%;
    }
    .len-remark {
        font-size: 10px;
        position: absolute;
        top: 45%;
        right: 23%;
    }
    .qrcode-content {
        font-size: 12px;
        text-align: center;
    }
    .footer-btn {
        text-align: center;
        .add {
            margin-right: 10px;
            
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
.el-popover {
    .content {
        font-size: 12px;
        line-height: 18px;
        padding: 4px 8px 8px;
        color: #5C667E;
        border: none;
        .sub-title {
            margin: 0;
        }
    }
    &.title-tips {
        p {
            color: #9AA7C1;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/rights/AddDevicesDialog.vue